import CloseIcon from "@mui/icons-material/Close";
import Box from "@mui/material/Box";
import IconButton from "@mui/material/IconButton";
import Modal from "@mui/material/Modal";
import Typography from "@mui/material/Typography";
import { useTranslation } from "react-i18next";
import DeviceHistory from "./DeviceHistory";

interface DeviceHistoryModalData {
  deviceId: string;
  deviceName?: string;
}

interface DeviceHistoryModalProps {
  open: boolean;
  handleClose: () => void;
  deviceId: DeviceHistoryModalData;
}

export default function DeviceHistoryModal({
  open,
  handleClose,
  deviceId: data,
}: DeviceHistoryModalProps) {
  const { t } = useTranslation();
  const { deviceId, deviceName } = data ?? {};

  return (
    <Modal open={open} onClose={handleClose}>
      <Box
        sx={{
          position: "absolute",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          width: "60%",
          height: "70vh",
          bgcolor: "background.paper",
          boxShadow: 24,
          borderRadius: 2,
          display: "flex",
          flexDirection: "column",
        }}
      >
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            px: 2,
            py: 1,
            borderBottom: 1,
            borderColor: "divider",
          }}
        >
          <Box>
            <Typography variant="h6">{t("deviceHistory.title")}</Typography>
            {deviceName && (
              <Typography variant="body2" color="text.secondary">
                {deviceName}
              </Typography>
            )}
          </Box>
          <IconButton size="small" onClick={handleClose}>
            <CloseIcon />
          </IconButton>
        </Box>
        <Box sx={{ flex: 1, overflow: "hidden" }}>
          <DeviceHistory deviceId={deviceId ?? ""} deviceName={deviceName} fullscreen />
        </Box>
      </Box>
    </Modal>
  );
}
